/**
 * Shared select.
 *
 * `defaultValue` here is the placeholder *label* ("Select country"), not a DOM
 * default, every caller uses it that way. It must never reach the <select>
 * element: a select that receives both `value` and `defaultValue` is neither
 * controlled nor uncontrolled, and React warns on every render. That warning
 * fired on every screen with a dropdown, which is most of the money flows.
 */
const Select = ({
  defaultValue = "",
  value,
  options = [],
  selectStyle,
  onChange,
  popupStyle,
  popupClassName = "",
  disabled,
  className = "",
}) => {
  // Controlled when the caller passes a value; uncontrolled otherwise. Never
  // both, hence the two mutually exclusive prop sets.
  const isControlled = value !== undefined;
  const selectProps = isControlled
    ? { value: value || "none" }
    : { defaultValue: "none" };

  return (
    <select
      className={`form-select ${className}`}
      style={selectStyle}
      disabled={disabled}
      onChange={onChange}
      {...selectProps}
    >
      <option value="none" disabled hidden>
        {defaultValue || "Select an option"}
      </option>
      {options.map((option, idx) => (
        <option
          key={option.value ?? idx}
          className={`fs14px ${popupClassName}`}
          style={popupStyle}
          value={option.value}
        >
          {option.name ?? option.label}
        </option>
      ))}
    </select>
  );
};

export default Select;
